"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _formatPhoneNumber = _interopRequireDefault(require("I18n/utils/formatPhoneNumber"));

var _default = _react.default.createClass({
  displayName: "FormattedPhoneNumber",
  propTypes: {
    value: _react.PropTypes.string.isRequired
  },
  render: function render() {
    var _this$props = this.props,
        value = _this$props.value,
        passThroughProps = (0, _objectWithoutProperties2.default)(_this$props, ["value"]);
    return _react.default.createElement("span", passThroughProps, (0, _formatPhoneNumber.default)(value));
  }
});

exports.default = _default;
module.exports = exports.default;